import React, { FunctionComponent, useId } from 'react'
import { BadgeOptionOverrides, mapContentToBadge } from 'components/TailwindUIToolkit/badges'

type Option = {
  label: string
  checked: boolean
  value: string | null | undefined
}

type OptionClickedFunction = (value: string | null | undefined, checked: boolean) => void

interface CheckboxListProps {
  options: Option[]
  onOptionClicked: OptionClickedFunction
  badgeOptions?: BadgeOptionOverrides
  sortByLabel?: boolean
}

export const CheckboxList: FunctionComponent<React.PropsWithChildren<CheckboxListProps>> = ({
  options,
  onOptionClicked,
  badgeOptions,
  sortByLabel = false
}) => {
  const sortedOptions = [...options].sort((a, b) =>
    sortByLabel ? a.label.localeCompare(b.label) : a.value?.localeCompare(b.value ?? '') ?? -1
  )
  return (
    <fieldset className='space-y-5 rounded-md p-4'>
      {sortedOptions.map((option) => {
        return (
          <CheckboxOption
            key={`${typeof option.value}:${String(option.value)}`}
            option={option}
            onOptionClicked={onOptionClicked}
            badgeOptions={badgeOptions}
          />
        )
      })}
    </fieldset>
  )
}

const CheckboxOption: FunctionComponent<
  React.PropsWithChildren<{
    onOptionClicked: OptionClickedFunction
    option: Option
    badgeOptions?: BadgeOptionOverrides
  }>
> = ({ option, onOptionClicked, badgeOptions }) => {
  const checkboxId = useId()
  return (
    <div className='relative flex items-start'>
      <div className='flex h-5 items-center'>
        <input
          id={checkboxId}
          name={option.label}
          onChange={(evt) => {
            onOptionClicked(option.value, evt.target.checked)
          }}
          checked={option.checked}
          type='checkbox'
          className='h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500'
        />
      </div>
      <div className='ml-3 text-sm'>
        <label htmlFor={checkboxId} className='font-medium text-gray-700'>
          {mapContentToBadge(option.label, badgeOptions)}
        </label>
      </div>
    </div>
  )
}
